import React from "react";

const DogBannersContext = React.createContext<{
  dogBanners: string[];
  setDogBanners: React.Dispatch<React.SetStateAction<string[]>>;
} | null>(null);

export default DogBannersContext;
